import BaseCarousel from "./BaseCarousel";
import {translate} from "../../utils";
import Item from "./Item";

export default class Carousel extends BaseCarousel {
    constructor() {
        super();

        //this.hide();
    }

    init(data) {
        for (let i = 0; i < data.length; i++) {
            const item = new Item(data[i]);
            this._itemHolder.addChild(item);
            this._items.push(item);
        }

        this._setItemPositions();
    }

    _setItemPositions() {
        super._setItemPositions();
    }

    next() {
        if (this._animating || this._selectionMade)
            return;

        super.next();
    }

    prev() {
        if (this._animating || this._selectionMade)
            return;

        super.prev();
    }
}